var _title, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "f8ab7373-691c-43a7-8cf6-6ae6155e5b57",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 512.18,
  cy: 457.64,
  r: 66.29
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M512.18,781.43h0a44.84,44.84,0,0,1-33.32-14.93C455.73,740.27,410.93,688,372,631c-50.45-73.76-75-130.39-75-173.37,0-118.55,96.52-215.07,215.07-215.07s215.07,96.52,215.07,215.07c0,42.8-24.58,99.61-75,173.37-39,57-83.77,109.44-106.9,135.49A43.5,43.5,0,0,1,512.18,781.43Zm0-491.69c-92.51,0-167.9,75.39-167.9,167.9,0,62.83,86.32,182.84,167.9,275.17,81.59-92.33,167.91-212.34,167.91-275.17C680.09,365,604.69,289.74,512.18,289.74Z"
})));
export default SvgIconMarker;